import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app-config';
import { CorePage } from './app/modules/_core/pages/core/core.page';
import { captureSelectedPlanFromUrl } from './app/shared/utils/selected-plan.util';

// Antes do bootstrap: a primeira navegação do roteador apaga a query da URL.
captureSelectedPlanFromUrl();

bootstrapApplication(CorePage, appConfig).catch(err => console.error(err));
